"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./AnnouncementBar.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function AnnouncementBar(_ref) {
  var children = _ref.children,
      onDismiss = _ref.onDismiss,
      margin = _ref.margin,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "onDismiss", "margin", "className"]);

  var cssClasses = ['st_announcement-bar'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_announcement-bar__content"
  }, children), /*#__PURE__*/_react["default"].createElement("button", {
    className: "st_announcement-bar__button",
    onClick: onDismiss,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "cross",
    size: "mlg"
  })));
}

AnnouncementBar.propTypes = {
  /** callback when announcement is dismissed */
  onDismiss: _propTypes["default"].func.isRequired,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for component, if any */
  margin: utils.spacing.marginProps
};
AnnouncementBar.defaultProps = {
  className: null,
  margin: null
};
var _default = AnnouncementBar;
exports["default"] = _default;